/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.10.1
 */
import { L as Label, d as defineCustomElement$1 } from './label2.js';

const CalciteLabel = Label;
const defineCustomElement = defineCustomElement$1;

export { CalciteLabel, defineCustomElement };

//# sourceMappingURL=calcite-label.js.map